import React from 'react';
import { CMSText } from './types';
import cx from '@utils/cx.util';
import { Markdown } from '@features/markdown/components/Markdown';

type Props = {
  component: CMSText;
};

const Description = ({ component }: Props) => {
  const {
    attributes: { value, cssClass = '', title, align = 'left' },
  } = component;

  return (
    <div className={cx('tw-mx-auto tw-max-w-[950px]', cssClass)}>
      {title && (
        <p className='tw-mb-3 tw-text-center tw-font-title tw-text-2xl tw-font-bold md:tw-mb-5'>{title}</p>
      )}
      <Markdown
        source={value}
        className={cx(
          'tw-text-left tw-text-sm tw-font-light tw-text-body md:tw-text-base [&_*]:tw-text-sm [&_*]:md:!tw-text-base [&_b]:tw-font-bold [&_p]:!tw-mb-3 last:[&_p]:!tw-mb-0',
          {
            'tw-text-center': align === 'center',
            'tw-text-right': align === 'right',
          }
        )}
      />
    </div>
  );
};

export default Description;
